import React, { useCallback, forwardRef } from 'react';
import type { ReactElement } from 'react';
import cx from 'classnames';

import styles from '../SwitchButton.module.sass';

export interface SwitchButtonProps {
  index: number;
  label: string | ReactElement;
  value: string;
  active: boolean;
  className?: string;
  tabIndex: number;

  onClick: (index: number) => void;
}

export const SwitchButtonItem = forwardRef<
  HTMLButtonElement | null,
  SwitchButtonProps
>((props, itemRef) => {
  const {
    index,
    label,
    value,
    active,
    className,
    tabIndex,

    onClick,
  } = props;

  const classes = cx(styles['switch-button__item'], {
    [styles['is-active']]: active,
  });

  const handleClick = useCallback(() => onClick(index), [index, onClick]);

  return (
    <button
      ref={itemRef}
      className={classes}
      value={value}
      tabIndex={tabIndex}
      onClick={handleClick}
      role="tab"
      type="button"
      aria-selected={active}
    >
      <span className={styles['switch-button__text']}>{label}</span>
    </button>
  );
});

SwitchButtonItem.displayName = 'SwitchButtonItem';
